export type TabItems = {
  key: string;
  title: string;
  to: string;
};

export const tabItems = [
  {
    key: 'tab-overview',
    to: '/admin/overview',
    title: 'Overview',
  },
  {
    key: 'tab-tracking',
    to: '/admin/tracking',
    title: 'Tracking',
  },
  {
    key: 'tab-agendas',
    to: '/admin/agendas',
    title: 'Agendas',
  },
  {
    key: 'tab-llm-traces',
    to: '/admin/llm-traces',
    title: 'LLM Traces',
  },
  {
    key: 'tab-llm-evaluations',
    to: '/admin/llm-evaluations',
    title: 'LLM Evaluations',
  },
];
